export const FOLLOW_UP_CONTENT_LIMIT = 100000;
export const FOLLOW_UP_BIZ_TYPES: Record<string, number> = {
  lead: 1,
  customer: 2,
  contact: 3,
  opportunity: 4,
  contract: 5,
  quote: 6,
  receipt: 7,
};

export function plainTextToMarkdown(text = '') {
  return text
    .replace(/([\\`*_{}[\]<>()#+.!|~>-])/g, '\\$1')
    .replace(/\r\n/g, '\n')
    .replace(/\n/g, '  \n');
}

export function followUpSummary(content = '', format?: string) {
  if (format !== 'markdown') return content;
  return content
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/[#*_~`>|]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

// Only these local references are fetched with CRM credentials.
export function crmAttachmentPath(url?: string) {
  if (!url) return undefined;
  return /^\/bff\/zy-crm\/attachments\/[a-zA-Z0-9-]+\/content(?:\?[^#]*)?$/.test(
    url,
  )
    ? url
    : undefined;
}

export function safeContentUrl(url: string) {
  if (crmAttachmentPath(url)) return url;
  return /^(https?:\/\/|mailto:)/i.test(url) ? url : '';
}
